import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUnarchiveVault() {
  const queryClient = useQueryClient()

  const action = async (id) => {
    return await httpClient.post(`team/vault/${id}/unarchive`)
  }

  return useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: (e) => {
      toast.success(e?.response?.data?.message ?? 'Vault has been unarchive.')
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
  })
}
